import React from "react";

type Props = {
  name?: string;          // nom du bloc pour le log
  fallback?: React.ReactNode; // UI à montrer si ça crash
  children: React.ReactNode;
};

type State = { hasError: boolean; error?: any };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  componentDidCatch(error: any, info: any) {
    // Log visible en prod pour déboguer rapidement
    // (tu peux remplacer par un appel API si tu veux)
    console.error("[ErrorBoundary]", this.props.name || "Block", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div style={{
            background: "rgba(255,255,255,0.06)",
            border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: 12,
            padding: 12,
            color: "#fca5a5",
            margin: "12px 0"
          }}>
            <strong>Une section a rencontré une erreur</strong>
            <div style={{ color: "#f87171", marginTop: 6, fontSize: 12 }}>
              {String(this.state.error ?? "Erreur inconnue")}
            </div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}